import React from 'react';
import styled from 'styled-components';

const BottomBar = () => {
    return (
        <Bar>
            <Disclaimer>
                <strong>Note:</strong> The 3D preview is for demonstration
                purposes only. Appliances are shown for visual reference and are
                not included in your order. Final product composition may change
                at manufacture.
            </Disclaimer>
            <Meta>
                <span>All measurements in mm</span>
            </Meta>
        </Bar>
    );
};

const Bar = styled.footer`
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    gap: 16px;
    min-height: 32px;
    padding: 6px 16px;
    background: #fff;
    border-top: 1px solid #eceff3;
    color: #6b7280;
    font-size: 12px;
    font-weight: 500;
    flex-shrink: 0;
    z-index: 20;
`;

const Disclaimer = styled.p`
    grid-column: 2;
    margin: 0;
    line-height: 1.3;
    text-align: center;
    white-space: nowrap;
`;

const Meta = styled.div`
    grid-column: 3;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    white-space: nowrap;
`;

export default BottomBar;
